export default __webpack_public_path__ + "static/4_34-82e4c6c0ab7b7e5a8e5a41df91f7244d.png";